import { AGGREGATORS, CHART_AGGREGATORS, CHART_TYPE, DS_ID } from 'src/constants/chart';

export default function dsSessionTrialData() {
  return {
    id: DS_ID.SESSION_TRIAL,
    label: this.$t('insights.chartConfigurator.sourcesSessionTrialDataLabel'),
    hasDateRange: true,

    // True when program type does not have to be loaded separately for filtering
    dataContainsProgramType: false,
    dataContainsTargetStatus: false,

    availableFilters: ['programs', 'programTags', 'programTypes', 'targetStatuses', 'users'],

    groupByOptions: [
      {
        label: this.$t('insights.chartConfigurator.groupByNoGroupLabel'),
        value: null,
        seriesLabelFrom: null,
      },
      {
        label: this.$t('insights.chartConfigurator.groupByProgramLabel'),
        value: 'programId',
        seriesLabelFrom: 'programName',
        seriesOrderBy: 'programName',
      },
      {
        label: this.$t('insights.chartConfigurator.groupByTargetLabel'),
        value: 'targetId',
        seriesLabelFrom: 'targetLabel',
        seriesOrderBy: 'targetOrder',
      },
      {
        label: this.$t('insights.chartConfigurator.groupByPromptLevelLabel'),
        value: 'promptLevelId',
        seriesLabelFrom: 'promptLevelLabel',
        seriesOrderBy: 'promptLevelOrder',
      },
      {
        label: this.$t('insights.chartConfigurator.groupByUserLabel'),
        value: 'userId',
        seriesLabelFrom: 'userName',
        seriesOrderBy: 'userName',
      },
      {
        label: this.$t('insights.chartConfigurator.groupByCurrentPromptLevelLabel'),
        value: 'currentPromptLevelId',
        seriesLabelFrom: 'promptLevelLabel',
        seriesOrderBy: 'promptLevelOrder',
      },
      {
        label: this.$t('insights.chartConfigurator.groupByMode'),
        value: 'mode',
        seriesLabelFrom: 'modeLabel',
        seriesOrderBy: 'mode',
      },
    ],

    xAxes: [
      {
        id: 'xaTrialBySession',
        label: this.$t('insights.chartConfigurator.xAxisTrialBySessionLabel'),
        chartType: CHART_TYPE.SCATTERCHART,
        xAxisType: 'category',
        xAxisAggregateBy: null,
        xAxisDataProperty: 'sessionTrial',
        xAxisCategoryLabel: 'sessionTrial',
        xAxisTimeUnit: null,
        xAxisOrderBy: 'date',
        xAxisSplitBy: 'sessionId',
        disableChartTypes: [
          CHART_TYPE.LINE,
          CHART_TYPE.COLUMN,
          CHART_TYPE.STACKED,
          CHART_TYPE.LOGARITHMIC,
          CHART_TYPE.SCATTERPLOT,
        ],
      },
      {
        id: 'xaTrialCumulative',
        label: this.$t('insights.chartConfigurator.xAxisTrialCumulativeLabel'),
        chartType: CHART_TYPE.SCATTERCHART,
        xAxisType: 'category',
        xAxisAggregateBy: null,
        xAxisDataProperty: 'cumulativeTrial',
        xAxisCategoryLabel: 'cumulativeTrial',
        xAxisTimeUnit: null,
        xAxisOrderBy: 'date',
        xAxisSplitBy: 'sessionId',
        disableChartTypes: [
          CHART_TYPE.LINE,
          CHART_TYPE.COLUMN,
          CHART_TYPE.STACKED,
          CHART_TYPE.LOGARITHMIC,
          CHART_TYPE.SCATTERPLOT,
        ],
      },
      {
        id: 'xaSession',
        label: this.$t('insights.chartConfigurator.xAxisSessionLabel'),
        chartType: CHART_TYPE.SCATTERCHART,
        xAxisType: 'category',
        xAxisAggregateBy: null,
        xAxisDataProperty: 'cumulativeSession',
        xAxisCategoryLabel: 'sessionDate',
        xAxisTimeUnit: null,
        xAxisOrderBy: 'date',
        xAxisSplitBy: 'sessionDateOnly',
      },
      {
        id: 'xaProgram',
        label: this.$t('insights.chartConfigurator.xAxisProgramLabel'),
        chartType: CHART_TYPE.SCATTERCHART,
        xAxisType: 'category',
        xAxisAggregateBy: null,
        xAxisDataProperty: 'programId',
        xAxisCategoryLabel: 'programName',
        xAxisTimeUnit: null,
        xAxisOrderBy: 'programName',
        xAxisSplitBy: null,
        disableChartTypes: [
          CHART_TYPE.LINE,
          CHART_TYPE.COLUMN,
          CHART_TYPE.STACKED,
          CHART_TYPE.LOGARITHMIC,
          CHART_TYPE.SCATTERPLOT,
        ],
      },
      {
        id: 'xaTarget',
        label: this.$t('insights.chartConfigurator.xAxisTargetLabel'),
        chartType: CHART_TYPE.SCATTERCHART,
        xAxisType: 'category',
        xAxisAggregateBy: null,
        xAxisDataProperty: 'targetId',
        xAxisCategoryLabel: 'targetLabel',
        xAxisTimeUnit: null,
        xAxisOrderBy: 'targetLabel',
        xAxisSplitBy: null,
        disableChartTypes: [
          CHART_TYPE.LINE,
          CHART_TYPE.COLUMN,
          CHART_TYPE.STACKED,
          CHART_TYPE.LOGARITHMIC,
          CHART_TYPE.SCATTERPLOT,
        ],
      },
      {
        id: 'xaPromptLevel',
        label: this.$t('insights.chartConfigurator.xAxisPromptLevelLabel'),
        chartType: CHART_TYPE.SCATTERCHART,
        xAxisType: 'category',
        xAxisAggregateBy: null,
        xAxisDataProperty: 'promptLevelId',
        xAxisCategoryLabel: 'promptLevelLabel',
        xAxisTimeUnit: null,
        xAxisOrderBy: 'promptLevelLabel',
        xAxisSplitBy: null,
        disableChartTypes: [
          CHART_TYPE.LINE,
          CHART_TYPE.COLUMN,
          CHART_TYPE.STACKED,
          CHART_TYPE.LOGARITHMIC,
          CHART_TYPE.SCATTERPLOT,
        ],
      },
      {
        id: 'xaUser',
        label: this.$t('insights.chartConfigurator.xAxisUserLabel'),
        chartType: CHART_TYPE.SCATTERCHART,
        xAxisType: 'category',
        xAxisAggregateBy: null,
        xAxisDataProperty: 'userId',
        xAxisCategoryLabel: 'userName',
        xAxisTimeUnit: null,
        xAxisOrderBy: 'userName',
        xAxisSplitBy: null,
        disableChartTypes: [
          CHART_TYPE.LINE,
          CHART_TYPE.COLUMN,
          CHART_TYPE.STACKED,
          CHART_TYPE.LOGARITHMIC,
          CHART_TYPE.SCATTERPLOT,
        ],
      },
    ],

    seriesPresets: [
      {
        id: 'spSuccessRate',

        label: this.$t('measurementMetrics.percentCorrect.label'),
        dataProperty: 'scoreValue',
        aggregator: AGGREGATORS.WEIGHTED_AVERAGE,
        chartAggregator: CHART_AGGREGATORS.WEIGHTED_AVERAGE,
        chartType: CHART_TYPE.SCATTERCHART,
        axis: 'percentage',
        axisCategory: null,
        axisCategoryLabel: null,
        hideColumnInTable: false,
        disableChartTypes: [CHART_TYPE.LINE, CHART_TYPE.COLUMN, CHART_TYPE.STACKED, CHART_TYPE.LOGARITHMIC],
      },
      {
        id: 'spSuccess',

        label: this.$t('insights.chartConfigurator.seriesSuccessfulObservations'),
        dataProperty: 'scoreValue',
        aggregator: AGGREGATORS.SUM,
        chartAggregator: CHART_AGGREGATORS.SUM,
        chartType: CHART_TYPE.SCATTERCHART,
        axis: 'number',
        axisCategory: null,
        axisCategoryLabel: null,
        hideColumnInTable: false,
        disableChartTypes: [CHART_TYPE.LINE, CHART_TYPE.COLUMN, CHART_TYPE.STACKED, CHART_TYPE.LOGARITHMIC],
      },
      {
        id: 'spOccurrences',
        label: this.$t('insights.chartConfigurator.seriesOccurrences'),
        dataProperty: 'scoreValue',
        aggregator: AGGREGATORS.COUNT,
        chartAggregator: CHART_AGGREGATORS.SUM,
        chartType: CHART_TYPE.SCATTERCHART,
        axis: 'number',
        axisCategory: null,
        axisCategoryLabel: null,
        hideColumnInTable: false,
        disableChartTypes: [CHART_TYPE.LINE, CHART_TYPE.COLUMN, CHART_TYPE.STACKED, CHART_TYPE.LOGARITHMIC],
      },
      {
        id: 'spTrial',
        label: this.$t('insights.chartConfigurator.seriesTrial'),
        dataProperty: 'scoreValue',
        aggregator: AGGREGATORS.COUNT,
        chartAggregator: CHART_AGGREGATORS.SUM,
        chartType: CHART_TYPE.SCATTERCHART,
        axis: 'category',
        axisCategory: null,
        axisCategoryLabel: 'trial',
        axisCategorySortBy: 'trial',
        hideColumnInTable: false,
        disableChartTypes: [
          CHART_TYPE.LINE,
          CHART_TYPE.COLUMN,
          CHART_TYPE.STACKED,
          CHART_TYPE.LOGARITHMIC,
          CHART_TYPE.SCATTERPLOT,
        ],
      },
      {
        id: 'spDurationGroup',
        label: this.$t('insights.chartConfigurator.seriesDuration'),
        isGroupHeader: true,
      },
      {
        id: 'spDuration',

        label: this.$t('insights.chartConfigurator.seriesDuration'),
        dataProperty: 'observationDuration',
        aggregator: AGGREGATORS.SUM,
        chartAggregator: CHART_AGGREGATORS.SUM,
        chartType: CHART_TYPE.SCATTERCHART,
        axis: 'duration',
        axisCategory: null,
        axisCategoryLabel: null,
        hideColumnInTable: false,
        disableChartTypes: [CHART_TYPE.LOGARITHMIC],
      },
      {
        id: 'spRatingScaleGroup',
        label: this.$t('insights.chartConfigurator.seriesRatingScale'),
        isGroupHeader: true,
      },
      {
        id: 'spAverageRating',
        label: this.$t('insights.chartConfigurator.seriesRatingLabel'),
        dataProperty: 'scoreValue',
        aggregator: AGGREGATORS.AVERAGE,
        chartAggregator: CHART_AGGREGATORS.AVERAGE,
        chartType: CHART_TYPE.SCATTERCHART,
        axis: 'number',
        axisNumberDecimals: 2,
        axisCategory: null,
        axisCategoryLabel: null,
        hideColumnInTable: false,
        disableChartTypes: [CHART_TYPE.LOGARITHMIC],

        yAxisMin: 'custom',
        yAxisMax: 'custom',
        yStrictMinMax: true,
      },
      {
        id: 'spProgramGroup',
        label: this.$t('insights.chartConfigurator.seriesProgram'),
        isGroupHeader: true,
      },
      {
        id: 'spTarget',
        label: this.$t('insights.chartConfigurator.seriesTarget'),

        dataProperty: 'scoreValue',
        aggregator: AGGREGATORS.COUNT,
        chartAggregator: CHART_AGGREGATORS.SUM,
        chartType: CHART_TYPE.SCATTERCHART,
        axis: 'category',
        axisCategory: 'targetId',
        axisCategoryLabel: 'targetLabel',
        axisCategorySortBy: 'targetOrder',
        axisCategorySortOrder: 'desc',
        hideColumnInTable: false,
        disableChartTypes: [
          CHART_TYPE.LINE,
          CHART_TYPE.COLUMN,
          CHART_TYPE.STACKED,
          CHART_TYPE.LOGARITHMIC,
          CHART_TYPE.SCATTERPLOT,
        ],
      },
      {
        id: 'spPromptLevel',
        label: this.$t('insights.chartConfigurator.seriesPromptLevel'),

        dataProperty: 'scoreValue',
        aggregator: AGGREGATORS.COUNT,
        chartAggregator: CHART_AGGREGATORS.SUM,
        chartType: CHART_TYPE.SCATTERCHART,
        axis: 'category',
        axisCategory: 'promptLevelId',
        axisCategoryLabel: 'promptLevelLabel',
        axisCategorySortBy: 'promptLevelOrder',
        axisCategorySortOrder: 'desc',
        hideColumnInTable: false,
        disableChartTypes: [
          CHART_TYPE.LINE,
          CHART_TYPE.COLUMN,
          CHART_TYPE.STACKED,
          CHART_TYPE.LOGARITHMIC,
          CHART_TYPE.SCATTERPLOT,
        ],
      },
    ],

    tableColumns: [
      {
        name: 'date',
        field: 'date',
        format: (val) => (val ? this.getLocaleDateString(val) : ''),
        label: this.$t('insights.chartConfigurator.columnsDate'),
        align: 'left',
        sortable: true,
        visibility: [null, 'sessionTrial', 'cumulativeTrial'],
        visibilityExport: ['sessionTrial', 'cumulativeTrial'],
      },
      {
        name: 'session',
        field: 'session',
        label: this.$t('insights.chartConfigurator.columnsSession'),
        align: 'left',
        sortable: true,
        visibility: ['sessionTrial', 'cumulativeTrial'],
        visibilityExport: ['sessionTrial', 'cumulativeTrial'],
      },
      {
        name: 'cumulativeTrial',
        field: 'cumulativeTrial',
        label: this.$t('insights.chartConfigurator.columnsCumulativeTrial'),
        align: 'left',
        sortable: true,
        visibility: ['cumulativeTrial'],
        visibilityExport: ['cumulativeTrial', 'sessionId', 'date'],
      },
      {
        name: 'trial',
        field: 'trial',
        label: this.$t('insights.chartConfigurator.columnsTrial'),
        align: 'left',
        sortable: true,
        visibility: ['sessionTrial'],
        visibilityExport: ['sessionTrial', 'sessionId', 'date'],
      },
      {
        name: 'programName',
        field: 'programName',
        label: this.$t('insights.chartConfigurator.columnsProgram'),
        align: 'left',
        sortable: true,
        classes: 'insights-truncate-label',
        visibility: ['programId', 'targetId'],
        visibilityExport: ['programId', 'targetId'],
      },
      {
        name: 'targetLabel',
        field: 'targetLabel',
        label: this.$t('insights.chartConfigurator.columnsTarget'),
        align: 'left',
        sortable: true,
        classes: 'insights-truncate-label',
        visibility: ['targetId'],
        visibilityExport: ['targetId'],
      },
      {
        name: 'promptLevelLabel',
        field: 'promptLevelLabel',
        label: this.$t('insights.chartConfigurator.columnsPromptLevel'),
        align: 'left',
        sortable: true,
        visibility: ['promptLevelId'],
        visibilityExport: ['promptLevelId'],
      },
      {
        name: 'userName',
        field: 'userName',
        label: this.$t('insights.chartConfigurator.columnsUser'),
        align: 'left',
        sortable: true,
        visibility: ['userId'],
        visibilityExport: ['userId'],
      },
    ],

    additionalSettings: [
      {
        id: 'hideDeletedTargets',
        label: this.$t('insights.chartConfigurator.hideDeletedTargetsDataLabel'),
        value: false,
      },
    ],
  };
}
